import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAllOperatorsOokla } from '@api/ookla';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IAllOperatorsOoklaDTO } from '@interfaces/platform/dto/ooklaDTO';

import { refetchOptions } from '@constants/common';
import { ALL_OPERATORS_OOKLA } from '@constants/queryKeys';

interface IUseQueryAllOperatorsOoklaReturn {
	isLoadingAllOperatorsOokla: boolean;
	allOperatorsOokla: Array<TSelectOption>;
}

export const useQueryAllOperatorsOokla = (): IUseQueryAllOperatorsOoklaReturn => {
	const {
		accessPermission: {
			assetConsumerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			assetOwnerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const isAllowed = (
		assetConsumerOrganizationAdministrator ||
		networkOperatorOrganizationAdministrator ||
		assetOwnerOrganizationAdministrator
	);

	const {
		data: allOperatorsOokla,
		isLoading: isLoadingAllOperatorsOokla,
		isFetching: isFetchingAllOperatorsOokla,
	} = useQuery({
			queryKey: [ALL_OPERATORS_OOKLA],
			queryFn: getAllOperatorsOokla,
			select: (operators: IAllOperatorsOoklaDTO[]) => {
				return operators?.map(item => {
					return {
						...item,
						value: item.id,
						name: item.name,
						label: item.name,
					};
				});
			},
			enabled: [isAllowed],
			...refetchOptions,
		},
	);

	return {
		isLoadingAllOperatorsOokla: isLoadingAllOperatorsOokla || isFetchingAllOperatorsOokla,
		allOperatorsOokla: allOperatorsOokla || [],
	};
};
